import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedWordTemplatesPanel } from "./LinkedWordTemplatesPanel";
import MultiLinkedWordTemplateList from "components/Picker/WordTemplatePicker/MultiLinkedWordTemplateList";

interface Props {
  bookkeepingId: number;
}

export const LinkedWordTemplatesToBookkeeping = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddWordTemplates = async (newWordTemplates: server.dto.WordTemplate[]) => {
    await window.CoreApi.Bookkeeping.LinkWordTemplates({
      bookkeepingId: props.bookkeepingId,
      wordTemplateForDetailViewIds: newWordTemplates.map(wt => wt.wordTemplateId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkWordTemplate = async (wordTemplate: server.dto.WordTemplate) => {
    await window.CoreApi.Bookkeeping.UnlinkWordTemplates({
      bookkeepingId: props.bookkeepingId,
      wordTemplateForDetailViewIds: [wordTemplate.wordTemplateId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedWordTemplatesPanel
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.WordTemplate.WordTemplates}
      noSelectionLabel={RESX.WordTemplate.NoWordTemplatesAssigned}
      listFunc={window.CoreApi.Bookkeeping.PaginatedLinkedWordTemplates}
      initialInstruction={{
        bookkeepingId: props.bookkeepingId,
        whereInOrNotIn: "in",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkWordTemplate}
      onAdd={() => setIsNewModalOpen(true)}
      onRemoveAll={() => window.CoreApi.Bookkeeping.UnlinkAllTemplatesForBookkeeping({
        bookkeepingId: props.bookkeepingId,
      })}
      onAddAll={() => window.CoreApi.Bookkeeping.LinkAllTemplatesForBookkeeping({
        bookkeepingId: props.bookkeepingId,
      })}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.WordTemplate.WordTemplates}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddWordTemplates}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedWordTemplateList
        initialInstruction={{
          bookkeepingId: props.bookkeepingId,
          whereInOrNotIn: "notIn",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.Bookkeeping.PaginatedLinkedWordTemplates}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};